import { z } from 'zod';
import { Option } from '../../types/Option';

export type CableSupportType = 'cable-ladder' | 'perforated-cable-tray' | 'unperforated-cable-tray';

const options = [
    { value: 'cable-ladder', label: 'Cable Ladder' },
    { value: 'perforated-cable-tray', label: 'Perforated Cable Tray' },
    { value: 'unperforated-cable-tray', label: 'Unperforated Cable Tray' },
] as Option<CableSupportType>[];

const validator = z.enum(['cable-ladder', 'perforated-cable-tray', 'unperforated-cable-tray']);

export const CableSupportType = {
    validator,
    options,
};
